import styled from 'styled-components';
import { Icon } from '../../../../components/common/icon/Icon';
import { useAppDispatch } from '../../../../hooks/store/useStore';
import { productFilterSlice } from '../../../../store/productFilterSlice';

export const EmptyList = () => {
  const dispatch = useAppDispatch();
  const productFilterActions = productFilterSlice.actions;

  const handleResetFilterButtonClick = () => {
    dispatch(productFilterActions.resetAllFilters());
  };

  return (
    <Container>
      <ContentsContainer>
        <TopSection>
          <Icon name={'BookBox'} width={60} height={60} />
        </TopSection>

        <BottomSection>
          <TextSection>
            <Title>{'앗! 죄송합니다'}</Title>
            <Description>{'찾고 계신 정보가 없네요.'}</Description>
          </TextSection>

          <GreyButton>
            <GreyButtonText onClick={handleResetFilterButtonClick}>{'초기화'}</GreyButtonText>
          </GreyButton>
        </BottomSection>
      </ContentsContainer>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;

  padding: 60px 16px;
`;

const ContentsContainer = styled.div`
  display: flex;
  flex-direction: column;

  gap: 24px;
`;

const TopSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const BottomSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: 16px;
`;

const TextSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: 4px;
`;

const Title = styled.span`
  color: var(--Light-Scheme-Monochrome-offblack, #505363);

  /* System/X-Large/xl-bold */
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 85%; /* 15.3px */
`;

const Description = styled.span`
  color: var(--Light-Scheme-Monochrome-grey70, #a7a9b6);
  text-align: center;

  /* Body/Medium/m-regular */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 21px */
`;

const GreyButton = styled.button`
  width: 167px;
  max-height: 40px;

  display: flex;
  justify-content: center;
  align-items: center;

  gap: 4px;

  padding: 16px;

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Monochrome-grey10, #f2f2f7);
`;

const GreyButtonText = styled.span`
  color: var(--Light-Scheme-Monochrome-grey100, #858894);

  /* System/Medium/m-medium */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 85%; /* 11.9px */
`;
